import { Typography } from '@mui/material';
import React from 'react';
export const useVolunteersColumns = ({ occupations }) => {
    const columns = React.useMemo(() => [
        {
            headerLabel: 'Name',
            sortKey: 'displayName',
            cellFunction: (row) => {
                return React.createElement(Typography, { variant: 'body2' }, row.columns.displayName);
            },
        },
        {
            headerLabel: 'Occupation',
            cellFunction: (row) => {
                const missionColumns = row.columns;
                return (React.createElement(Typography, { variant: 'body2' }, missionColumns.occupationIds
                    .map((occupationId) => occupations[occupationId])
                    .filter(Boolean)
                    .join(', ')));
            },
        },
    ], [occupations]);
    return { columns };
};
